import { ApiRequest, RequestMethod } from "../../request";

export async function increaseLevel(
  fighterId: string,
  advancementIds: string[],
  experience: number
): Promise<boolean> {
  const apiRequest = new ApiRequest();

  const URL = `/api/fighter/${fighterId}/increase-level`;

  apiRequest.setMethod(RequestMethod.POST);
  apiRequest.setUrl(URL);

  apiRequest.setJsonBody({
    fighterId: fighterId,
    advancementIds: advancementIds,
    exp: experience
  });

  const response: any = await apiRequest.send();

  return response.status === 200;
}
